import Layout from './components/Layout'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import Home from './pages/Home'
import Login from './pages/Login'
import CreateAccount from './pages/CreateAccount'
import SimMangement from './pages/SimMangement'
import Plan from './pages/Plan'
import Signup from './pages/Signup'
import Step1 from './pages/Step1'
import Step2 from './pages/Step2'
import Transactions from './pages/Transactions'
import Yourticket from './pages/Yourticket'
import CreateTicket from './pages/CreateTicket'
import Superadmin from './pages/Superadmin'
import SuperadminWallet from './pages/SuperadminWallet'
import HelpSupport from './pages/HelpSupport'
import StepHeader from './pages/StepHeader'
import SimManagement from './pages/SimManagement'
import Apibox from './pages/Apibox'
import News from './pages/News'
import SuperadminDashboard from './pages/SuperadminDashboard'
import UserProfile from './pages/UserProfile'
import Forgotpassword from './pages/Forgotpassword'
import AddmoreBalance from './pages/AddmoreBalance'
import SuperadminTicket from './pages/SuperadminTicket'
import SuperadminPartner from './pages/SuperadminPartner'
import SuperadminVendor from './pages/SuperadminVendor'
import Superadminpay from './pages/Superadminpay'
import SuperadminUpdate from './pages/SuperadminUpdate'
import TermsOfUse from './pages/Terms&Use'
import PrivacyPolicy from './pages/Terms&Privacy'

import BuyDataBundles from './pages/Esimstoreold/BuyDataBundles'
import Buydatad from './pages/Esimstoreold/Buydatad'
import CallEventsTable from './pages/Esimstoreold/CallEventTable'
import BuyDataGlobal from './pages/Esimstoreold/BuyDataGlobal'
import BuyPremiumplan from './pages/BuyPremiumplan'
import BuyUKplan from './pages/BuyUKplan'
import InventoryUpload from './pages/InventoryUpload'
import InventoryVendor from './pages/InventoryVendor'
import Superadminplan from './pages/Superadminplan'
import InventoryPlan from './pages/InventoryPlan'
import InventoryCustomer from './pages/InventoryCustomer'
import InventoreCustomPlan from './pages/InventoreCustomPlan'


import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SessionTimeoutModal from './components/SessionTimeoutModal';
import PaymentSuccess from './pages/PaymentSuccess'
import BuyTopupHistory from './pages/BuyTopupHistory'
import PaymentCancelPage from './pages/PaymentCancel'
import Renew from './pages/Renew'
import SuperadminRenewal from './pages/SuperadminRenewal'
import ExcelViewer from './Pwg/Orderdetails'
import Cdrtable from './Pwg/Cdrtable'
import EsimStore from './pages/EsimStore'
import ActicationPWG from './Pwg/ActivationPWG'
import SwapMDN from './Pwg/SwapMDN'
import BillingCode from './Pwg/BillingCode'
import Superadmintrasn from './pages/Superadmintrasn'
import DefaultDashboard from './pages/Home'
import Topup from './pages/Topup'
import Superadmincredit from './pages/Superadmincredit'
import Bar1 from './pages/Bar1'
import SubUser from './pages/SubUser'
import Uspwgpurchase from './pages/Uspwgpurchase'
import SimStore from './pages/SimStore'
// import BuyTopUp from './pages/BuyTopUp'

function App() {  
    return (
        <BrowserRouter>
            <Layout>
                <ToastContainer />
                <SessionTimeoutModal />
                <Routes>
                    <Route path='/' element={<Login />} />
                    <Route path='/Login' element={<Login />} />
                    <Route path='/Signup' element={<Signup />} />      
                    <Route path ='Forgotpassword' element={<Forgotpassword />}/>

                    {/* SIDEBAR PARTNER ROUTES */}

                    <Route path='/Home' element={<Home />} />
                    <Route path='/BuyDataBundles' element={<BuyDataBundles />} />
                    <Route path ='Transactions' element={<Transactions />}/>
                    <Route path ='AddmoreBalance' element={<AddmoreBalance />}/>
                    <Route path='/News' element={<News />} />
                    <Route path='/SimMangement' element={<SimMangement />} />
                    <Route path='/Apibox' element={<Apibox />} />
                    <Route path ='/HelpSupport' element={<HelpSupport />}/>
                    <Route path='/CreateTicket' element={<CreateTicket />} />      

                    {/* OTHER PARTNER ROUTES ARE */}

                    <Route path='/Plan' element={<Plan />} />
                    <Route path='/CreateAccount' element={<CreateAccount />} />
                    <Route path ='/UserProfile' element={<UserProfile />}/>
                    <Route path='/Yourticket' element={<Yourticket />} />      
                    <Route path='/BuyDataGlobal' element={<BuyDataGlobal />} />      
                    
                    <Route path='/CallEventsTable' element={<CallEventsTable  />} />    
                    <Route path="/payment-success" element={<PaymentSuccess />} />
                    {/* <Route path="/BuyTopUp" element={<BuyTopUp />} /> */}
                   <Route path="/cancel" element={<PaymentCancelPage />} />
                    <Route path="/BuyTopupHistory" element={<BuyTopupHistory />} />
                   
                    {/* ALL STEPS ROUTES */}

                    <Route path='/Step1' element={<Step1 />} />
                    <Route path='/Step2' element={<Step2 />} />
                    <Route path ='/StepHeader' element={<StepHeader />}/>


                    {/* superadmin access */}
                    <Route path ='/SuperadminDashboard' element={<SuperadminDashboard />}/>
                    <Route path ='/Superadmin' element={<Superadmin />}/>
                    <Route path ='/SuperadminWallet' element={<SuperadminWallet />}/>
                    <Route path ='SuperadminTicket' element={<SuperadminTicket />}/>
                    <Route path ='SuperadminPartner' element={<SuperadminPartner />}/>
                    <Route path ='SuperadminVendor' element={<SuperadminVendor />}/>
                    <Route path ='Superadminpay' element={<Superadminpay />}/>
                    <Route path ='SuperadminUpdate' element={<SuperadminUpdate />}/>

                    
                   {/* Temporay Routes for future reference */}
                   <Route path='/TermsOfUse' element={<TermsOfUse />} />
                   <Route path='/PrivacyPolicy' element={<PrivacyPolicy />} />
                   
                    <Route path='/SimManagement' element={<SimManagement />} />
                    <Route path='/Buydatad' element={<Buydatad />} />  
                    <Route path='/EsimStore' element={<EsimStore />} />  
                    <Route path='/BuyPremiumplan' element={<BuyPremiumplan />} />  
                    <Route path='/BuyUKplan' element={<BuyUKplan />} />  
                    <Route path='/InventoryUpload' element={<InventoryUpload />} />  
                    <Route path='/InventoryVendor' element={<InventoryVendor />} />  
                    <Route path='/InventoryPlan' element={<InventoryPlan />} />  
                    <Route path='/InventoryCustomer' element={<InventoryCustomer />} />  
                    <Route path='/InventoreCustomPlan' element={<InventoreCustomPlan />} />  

                    <Route path='/Superadminplan' element={<Superadminplan />} />  
                    <Route path='/SuperadminRenewal' element={<SuperadminRenewal />} />  
                    <Route path='/Superadmintrasn' element={<Superadmintrasn />} />  

                    <Route path='/ExcelViewer' element={<ExcelViewer />} />  
                    <Route path='/Cdrtable' element={<Cdrtable />} />  
                    <Route path='/ActicationPWG' element={<ActicationPWG />} />  
                    <Route path='/SwapMDN' element={<SwapMDN />} />  
                    <Route path='/BillingCode' element={<BillingCode />} />  
                    <Route path='/DefaultDashboard' element={<DefaultDashboard />} />  
                    <Route path='/Topup' element={<Topup />} />  
                    <Route path='/Superadmincredit' element={<Superadmincredit />} />  
                    <Route path='/Bar1' element={<Bar1 />} />  

{/* //Layout mai bhi change kiye hai activeplan */}
                {/* <Route path='/Logic' element={<Logic />} />  
                <Route path='/CreatePlan' element={<CreatePlan />} />  
                <Route path='/Inventroydetails' element={<Inventroydetails />} />   */}
                <Route path='/ExcelViewer' element={<ExcelViewer />} />  
                <Route path='/SubUser' element={<SubUser />} />  
                {/* //Sameer */}
                    <Route path='/Uspwgpurchase' element={<Uspwgpurchase />} />  
                    <Route path='/SimStore' element={<SimStore />} />  

                </Routes>

            </Layout>
        </BrowserRouter>
    )
}

export default App
